import type { MetronomeMode } from '../types';

interface MetronomeModePickerProps {
  mode: MetronomeMode;
  recordMs?: number;
  onModeChange: (mode: MetronomeMode) => void;
}

function formatRecord(ms: number): string {
  const total = Math.max(0, Math.floor(ms / 1000));
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}

/** Vælg klassisk rytme-runde eller overlevelse (ingen fejl). */
export default function MetronomeModePicker({
  mode,
  recordMs = 0,
  onModeChange,
}: MetronomeModePickerProps) {
  return (
    <div className="mt-5 rounded-xl bg-white/70 p-4 text-left ring-1 ring-emerald-200/80 dark:bg-zinc-900/50 dark:ring-emerald-500/25">
      <p className="text-xs font-semibold text-strong">Tilstand</p>
      <div className="mt-2 grid gap-2 sm:grid-cols-2">
        <button
          type="button"
          onClick={() => onModeChange('classic')}
          className={`rounded-lg px-3 py-2 text-left text-sm ring-1 transition ${
            mode === 'classic'
              ? 'bg-emerald-50 ring-emerald-400 dark:bg-emerald-500/10 dark:ring-emerald-500/40'
              : 'bg-zinc-50 ring-zinc-200 hover:bg-zinc-100 dark:bg-zinc-900/60 dark:ring-white/5'
          }`}
        >
          <span className="font-semibold text-strong">Klassisk</span>
          <span className="mt-0.5 block text-xs text-muted">
            Skriv hele teksten i takten.
          </span>
        </button>
        <button
          type="button"
          onClick={() => onModeChange('survival')}
          className={`rounded-lg px-3 py-2 text-left text-sm ring-1 transition ${
            mode === 'survival'
              ? 'bg-emerald-50 ring-emerald-400 dark:bg-emerald-500/10 dark:ring-emerald-500/40'
              : 'bg-zinc-50 ring-zinc-200 hover:bg-zinc-100 dark:bg-zinc-900/60 dark:ring-white/5'
          }`}
        >
          <span className="font-semibold text-strong">Overlevelse</span>
          <span className="mt-0.5 block text-xs text-muted">
            Bliv ved uden fejl — hold takten.
          </span>
        </button>
      </div>
      {mode === 'survival' && recordMs > 0 && (
        <p className="mt-3 text-xs text-muted">
          Din rekord:{' '}
          <span className="font-mono font-semibold text-strong">
            {formatRecord(recordMs)}
          </span>
        </p>
      )}
    </div>
  );
}
